import http from './http' // needs this file in the same directory

export default {
  index(){
    return http.get(`/litigations`);
  },

  show(item_id){
    return http.get(`/litigations/`+item_id);
  },

  create(new_item){
    return http.post(`/litigations`,{
      litigation:{ 
        name:            new_item.name,
        description:     new_item.description,
        folder:          new_item.folder,
        court:           new_item.court,
        county:          new_item.county,
        client_is:       new_item.client_is,
        other_part:      new_item.other_part,
        maintenance_fee: new_item.maintenance_fee? new_item.maintenance_fee.replace(/,/g, '') : null,
        comment:         new_item.comment,
        progresses_attributes:         new_item.progresses_attributes,
      }
    });
  },

  update(update_item){
    return http.put(`/litigations/${update_item.id}`,{
      litigation:{ 
        id: update_item.id,

        name:            update_item.name,
        description:     update_item.description,
        folder:          update_item.folder,
        court:           update_item.court,
        county:          update_item.county,
        client_is:       update_item.client_is,
        other_part:      update_item.other_part,
        maintenance_fee: update_item.maintenance_fee? update_item.maintenance_fee.replace(/,/g, '') : null,
        comment:         update_item.comment,
        progresses_attributes:         update_item.progresses_attributes,

      }
    });
  },

  updateToDelete(update_item){
    return http.delete(`/litigations/${update_item}`);
  },

}